import { render, staticRenderFns } from "./MailEmpfaengerAbsender.vue?vue&type=template&id=10c81a48"
import script from "./MailEmpfaengerAbsender.vue?vue&type=script&lang=js"
export * from "./MailEmpfaengerAbsender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports